import React from 'react';

import config from "../config/config";

import IFrame from '../components/iframe';
import { useSearchParams } from 'react-router-dom';

const iframeURL = `${config.DOMAIN_NAME}/${config.CLIENT_NAME}/website/GiftVouchers.aspx?resize=true`;

const thumbnail = config.OPTION_FIELDS.gift_voucher_thumbnail?.image?.innerHTML ?? null;
const thumbnail_background = config.OPTION_FIELDS.gift_voucher_thumbnail?.background?.innerHTML ?? null;

export default function IframeGiftVouchers() {
    const [searchParams] = useSearchParams();
    const membershipId = searchParams.get("membership")?.match(/^\d+/)?.[0];

    return (
        <>
        {thumbnail &&
            <div className='booking-pathway__container-image'>
                <div className="article-image has-image">
                    <span className="gradient"></span>
                    <div className="article-image-inner" style={{backgroundImage: `url(${thumbnail_background})`}}>
                        <div className="article-image-container" 
                            dangerouslySetInnerHTML={{
                                __html: thumbnail
                            }}
                        >
                        </div>                
                    </div>
                </div>
            </div>
        }
        <div className='booking-pathway__container booking-pathway__iframe-gift-voucher'>            
            <div className='booking-pathway__main-content'>
                <h1 className='sr-only'>Gift Vouchers</h1>
                <IFrame url={iframeURL + (membershipId ? `&MembershipId=${membershipId}` : "")} title="Gift Vouchers" hasLoader="true" />
            </div>
        </div>
        </>
    );
}